import {
  Box,
  Spinner as ChakraUISpinner,
  SpinnerProps as ChakraUISpinnerProps
} from "@chakra-ui/react";

import type { ReactNode } from "react";

export interface SpinnerProps
  extends Pick<
    ChakraUISpinnerProps,
    "label" | "size" | "emptyColor" | "speed" | "thickness"
  > {
  children?: ReactNode;
}

export function Spinner(props: SpinnerProps) {
  const { children } = props;

  if (children) {
    return (
      <Box position="relative">
        <ChakraUISpinner
          {...props}
          position="absolute"
          top="50%"
          left="50%"
          display="block"
        />
        <Box opacity={0.5} userSelect="none" pointerEvents="none">
          {children}
        </Box>
      </Box>
    );
  }
  return <ChakraUISpinner {...props} />;
}
